import React, { memo } from "react"
import { useInfiniteQuery } from "@tanstack/react-query"
import { API_ENDPOINTS } from "@constants"

import { VirtualList, paginated, apiClient, ErrorWithRefetch } from "@dit/core-frontend"
import { Box, Stack, Text } from "@mos-cat/ds"
import { FeedItem } from "../../Home/components/FeedBlock/FeedItem"
import { MODULE_TYPE } from "@utils/profilePage"

import styles from "../userProfilePage.module.css"

const LIMIT = 10

const ListRow = memo(({ page, rowRef, ...rowProps }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gridGap="10px"
      p="6px 10px"
      borderWidth="1px"
      borderColor="gray-05"
      ref={rowRef}
      styles={{
        "& > div": {
          maxWidth: "100%",
        },
      }}
      {...rowProps}
    >
      <Box display="flex" alignItems="center" gridGap="10px">
        {page.title}
      </Box>
    </Box>
  )
})

ListRow.displayName = "ListRow"

export const UserActionsList = memo(({ isVisible, params }) => {
  const { module, profileId } = params

  const moduleInfoApi =
    module === MODULE_TYPE.TRACK
      ? `${API_ENDPOINTS.userInfoTrack}/${profileId}/feed`
      : `${API_ENDPOINTS.userInfoWiki}/${profileId}/feed`

  const { isFetching, data, fetchNextPage, hasNextPage, error, refetch } = useInfiniteQuery({
    ...paginated({
      queryKey: [`profile-actions-${moduleInfoApi}`, params, moduleInfoApi],
      queryFn: (pagginated) =>
        apiClient.get(moduleInfoApi, {
          params: {
            epp: LIMIT,
            sortDirection: "desc",
            onlyUserActivity: true,
            ...pagginated,
          },
        }),
    }),
    staleTime: 0,
    enabled: isVisible,
  })

  return (
    <Box>
      <Text as={Box} className={styles.title}>
        Активность
      </Text>
      {error && <ErrorWithRefetch refetch={refetch} />}
      {data && (
        <Stack space="0">
          <VirtualList
            over={10}
            dataList={data.items}
            dataTotal={data.total}
            height={440}
            renderItem={(item, index) => (
              <FeedItem key={`feed-${item.user.id}-${index}`} item={item} isProfilePage />
            )}
            isLoading={isFetching}
            onLoad={fetchNextPage}
            hasNextPage={hasNextPage}
          />
        </Stack>
      )}
    </Box>
  )
})

UserActionsList.displayName = "UserActionsList"
